@if (drawerVisible()) {
      <aside
        #howToPanelRoot
        class="how-to-drawer-panel how-to-side-panel"
        [class.how-to-side-panel--minimized]="drawerMinimizedToFloating()"
        aria-label="How-To articles"
        [attr.aria-hidden]="drawerMinimizedToFloating() ? 'true' : null"
      >
        <header class="how-to-dock-header">
          <div class="how-to-dock-header__actions">
            <button
              type="button"
              nz-button
              nzType="text"
              class="how-to-dock-header__icon-btn"
              nz-tooltip
              nzTooltipTitle="Hide panel (floating button)"
              nzTooltipPlacement="bottom"
              aria-label="Minimize How-To panel to floating button"
              (click)="collapseHowToToFloating()"
            >
              <span nz-icon nzType="unordered-list" nzTheme="outline" aria-hidden="true"></span>
            </button>
            <button
              type="button"
              class="how-to-dock-header__icon-btn how-to-dock-header__icon-btn--close"
              aria-label="Close How-To"
              (click)="closeDrawer()"
            >
              <span nz-icon nzType="close" nzTheme="outline" aria-hidden="true"></span>
            </button>
          </div>
        </header>
        <div class="how-to-side-panel-body">
        <div class="how-to-drawer-shell">
          <hr
            class="how-to-drawer-splitter"
            aria-orientation="vertical"
            aria-label="Resize How-To drawer width"
            nz-tooltip
            nzTooltipTitle="Drag to resize drawer"
            nzTooltipPlacement="right"
            (pointerdown)="onDrawerSplitterPointerDown($event)"
            (pointermove)="onDrawerSplitterPointerMove($event)"
            (pointerup)="onDrawerSplitterPointerUp($event)"
            (pointercancel)="onDrawerSplitterPointerUp($event)"
            (keydown)="onDrawerSplitterKeydown($event)"
          />
          <div class="how-to-drawer-body">
            <div class="how-to-drawer-inner">
      <header class="how-to-header">
        <div class="how-to-header-bg" aria-hidden="true"></div>
        <div class="how-to-header-content">
          <span class="how-to-header-logo-wrap">
            <img
              [src]="quinnyAiBannerLogoUrl"
              alt=""
              class="how-to-header-logo"
              role="presentation"
            />
          </span>
          <div class="how-to-header-text">
            <h2 class="how-to-header-title">Quinny AI Learning</h2>
          </div>
        </div>
      </header>

      <main class="how-to-main">
        @if (loading()) {
          <div class="how-to-loading">
            <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
            <p class="how-to-loading-text">Loading articles…</p>
          </div>
        } @else if (totalArticleCount() === 0) {
          <div class="how-to-empty">
            <div class="how-to-empty-icon-wrap">
              <i nz-icon nzType="book" nzTheme="outline"></i>
            </div>
            <p class="how-to-empty-title">No articles yet</p>
            <p class="how-to-empty-desc">Related guides for this screen will appear here when available.</p>
          </div>
        } @else {
          @if (articleSections().length === 1) {
            <p class="how-to-list-label">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
              <span>Articles ({{ totalArticleCount() }})</span>
            </p>
          }
          @for (section of articleSections(); track section.scope) {
            <section class="how-to-scope-section">
              @if (articleSections().length > 1) {
                <p class="how-to-list-label how-to-scope-heading">
                  <i nz-icon nzType="folder" nzTheme="outline"></i>
                  <span>{{ section.scope }}</span>
                  <span class="how-to-scope-count">({{ section.articles.length }})</span>
                </p>
              }
              @if (section.articles.length === 0) {
                @if (articleSections().length > 1) {
                  <p class="how-to-scope-empty">No articles for this topic.</p>
                }
              } @else {
                <nz-collapse
                  [nzBordered]="false"
                  class="how-to-collapse"
                  [nzExpandIconPosition]="howToCollapseExpandIconPosition"
                >
                  @for (a of section.articles; track a.articleUrl) {
                    <ng-container>
                      <ng-template #howToArticleHeaderTpl>
                        <span class="how-to-collapse-panel-header">
                          <i
                            nz-icon
                            nzType="file-text"
                            nzTheme="outline"
                            class="how-to-collapse-panel-header-icon"
                            aria-hidden="true"
                          ></i>
                          <span class="how-to-collapse-panel-header-title">{{ a.title }}</span>
                        </span>
                      </ng-template>
                      <ng-template #howToArticleExtraTpl>
                        <button
                          type="button"
                          nz-button
                          nzType="text"
                          class="how-to-panel-external-btn"
                          nz-tooltip
                          nzTooltipTitle="Open on support site"
                          nzTooltipPlacement="top"
                          (click)="openArticleExternal($event, a.articleUrl)"
                          aria-label="Open article on support site in new tab"
                        >
                          <i nz-icon nzType="export" nzTheme="outline"></i>
                        </button>
                      </ng-template>
                      <nz-collapse-panel
                        [nzHeader]="howToArticleHeaderTpl"
                        [nzExtra]="howToArticleExtraTpl"
                        [nzActive]="isPanelActive(a.articleUrl)"
                        (nzActiveChange)="onPanelActiveChange(a, $event)"
                      >
                        @if (isArticleLoading(a.articleUrl)) {
                          <div class="how-to-panel-loading">
                            <nz-spin nzSimple></nz-spin>
                            <span>Loading article…</span>
                          </div>
                        } @else {
                          @if (articleHtml(a.articleUrl); as safeHtml) {
                            <div class="how-to-article-html" [innerHTML]="safeHtml"></div>
                          } @else if (articleHasError(a.articleUrl)) {
                            <p class="how-to-panel-error">This article could not be loaded here.</p>
                            <button
                              type="button"
                              nz-button
                              nzType="default"
                              (click)="openArticle(a.articleUrl)"
                            >
                              Open article in new tab
                            </button>
                          }
                        }
                      </nz-collapse-panel>
                    </ng-container>
                  }
                </nz-collapse>
              }
            </section>
          }
        }
      </main>

      <footer class="how-to-footer">
        <button
          type="button"
          class="how-to-explore-more-btn"
          (click)="openExploreMore()"
        >
          <span class="how-to-explore-more-btn-surface">
            <span class="how-to-explore-more-sparkles" aria-hidden="true">
              <svg
                class="how-to-explore-more-sparkle-svg"
                width="40"
                height="24"
                viewBox="0 0 40 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
              >
                <defs>
                  <linearGradient
                    [attr.id]="exploreSparkleGradientId"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop offset="0%" stop-color="#0b6fd8" />
                    <stop offset="52%" stop-color="#0a7ae8" />
                    <stop offset="100%" stop-color="#5ce8ff" />
                  </linearGradient>
                </defs>
                <path
                  [attr.fill]="'url(#' + exploreSparkleGradientId + ')'"
                  d="M8 2 10 8 16 11 10 14 8 20 6 14 0 11 6 8Z"
                />
                <path
                  [attr.fill]="'url(#' + exploreSparkleGradientId + ')'"
                  transform="translate(17 4.5) scale(0.78)"
                  d="M8 2 10 8 16 11 10 14 8 20 6 14 0 11 6 8Z"
                />
              </svg>
            </span>
            <span class="how-to-explore-more-text">View More Articles</span>
          </span>
        </button>
      </footer>
            </div>
          </div>
        </div>
        </div>
      </aside>
    }

    <ng-template #howToRestoreFabIconTpl>
      <span nz-icon nzType="book" nzTheme="outline" aria-hidden="true"></span>
    </ng-template>
    @if (drawerMinimizedToFloating()) {
      <nz-float-button
        class="page-how-to-floating-restore"
        nzType="primary"
        nzShape="circle"
        [nzIcon]="howToRestoreFabIconTpl"
        nz-tooltip
        nzTooltipTitle="Open How-To"
        nzTooltipPlacement="left"
        aria-label="Open How-To panel"
        (nzOnClick)="openDrawer()"
      />
    }
